import HeaderRect from './HeaderRect'
export default HeaderRect
